
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/rewards/[rewardKey]",
      function () {
        return require("private-next-pages/event/rewards/[rewardKey].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event/rewards/[rewardKey]"])
      });
    }
  